export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '电子科大虚拟仿真系统',
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    locale: 'zh',
    /**
     * @description 基础url
     */
    baseUrl:'https://vlab.uestc.edu.cn/finance',
    /**
     * @description 基础模式子系统链接
     */
    subSystem1:'https://vlab.uestc.edu.cn/finance/kd/#/Dashboard',
    /**
     * @description 挑战模式子系统链接
     */
    subSystem2:'https://vlab.uestc.edu.cn/finance/kdChallenge/#/Dashboard',
    /**
     * @description 期货模式
     */
    subSystem3:'https://vlab.uestc.edu.cn/finance/future/#/Dashboard',
     /**
     * @description 期货套利模式
     */
    subSystem4:'https://vlab.uestc.edu.cn/finance/futureArbitrage/#/Dashboard',
     /**
     * @description 期权交易模式
     */
    subSystem5:'https://vlab.uestc.edu.cn/finance/optionArbitrage/#/Dashboard',
     /**
     * @description 半个小时未操作，自动退出登录时间
     */
    autoLogoutTime: 1800000,
}